import { OfficeButton, PopUp } from "components";
import {
  RenewFacOffer,
  RenewFacOfferVariables,
} from "_graphql/mutation/kek/__generated__/RenewFacOffer";

import { LocationGenerics } from "router/location";
import { renewFacOffer } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RenewContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    RenewFacOffer,
    RenewFacOfferVariables
  >(renewFacOffer, {
    refetchQueries: ["KEKOffers"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        offerId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.renewFacOffer) {
        toast.success("Offer Renewed Successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Could not renew offer");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title="Renew Offer"
      cancelText="No, Don't Renew Offer"
      variant="warning"
      description="This action would renew offer details for editing"
      renderActions={() => (
        <>
          <OfficeButton
            variant="warning"
            size="sm"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "Renewing Offer..." : "Renew Offer"}
          </OfficeButton>
        </>
      )}
    />
  );
}
